import { render, staticRenderFns } from "./permission-content.vue?vue&type=template&id=9055ad3e&scoped=true&"
import script from "./permission-content.vue?vue&type=script&lang=js&"
export * from "./permission-content.vue?vue&type=script&lang=js&"
import style0 from "./permission-content.vue?vue&type=style&index=0&id=9055ad3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9055ad3e",
  null
  
)

export default component.exports